import * as Sentry from '@sentry/browser';

Sentry.init({
    dsn: 'https://ba5b0723d45a023d3be863ff7f89681b@o4510938538704896.ingest.us.sentry.io/4510938567671808',

    integrations: [Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] })],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    tracesSampleRate: 1.0,

    beforeSend(event) {
        const maskPII = (str) => str.replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, '[EMAIL_FILTERED]');

        if (event.request && event.request.url) {
            event.request.url = maskPII(event.request.url);
        }

        // Broad scrubbing of message and extra data
        if (event.message) event.message = maskPII(event.message);
        if (event.extra) {
            Object.keys(event.extra).forEach((key) => {
                if (typeof event.extra[key] === 'string') {
                    event.extra[key] = maskPII(event.extra[key]);
                }
            });
        }

        return event;
    },

    _experiments: {
        enableLogs: true,
    },
});

export const { logger } = Sentry;
